import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from "react-router-dom";

interface NavbarProps {
    page: string;
}

function Navbar(props: NavbarProps) {
    const { page } = props;

    const [showSidebar, setShowSidebar] = useState(false);
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        // Other stuff
        let onPageScroll = (event: Event) => { setScrollY(window.pageYOffset); };
        let onPageResize = () => { if(window.innerWidth >= 1024) { setShowSidebar(false); } };

        window.addEventListener("scroll", onPageScroll, { passive: true });
        window.addEventListener("resize", onPageResize, { passive: true });

        onPageResize();

        return () => { 
            window.removeEventListener("scroll", onPageScroll); 
            window.removeEventListener("resize", onPageResize); 
        }
    }, []);

    const onToggleSidebar = (open: boolean) => { setShowSidebar(open); }

    return (
        <>
            <nav id="navigation-topbar" className={`fixed w-full z-20 top-0 left-0 transition-all bg-gray-900 text-white px-3 py-2.5 xl:px-5`}>
                <div className='flex items-center justify-between'>
                    <div className='flex items-center justify-start'>
                        <a href="#" className='text-white text-xl mr-10 tracking-wide'>SimonSays' Convert</a>
                        <div className="items-center justify-between hidden lg:flex" id="mobile-menu-2">
                            <ul className="flex items-center justify-between">
                                <li><Link to={`/`} className={`lg:mr-2 xl:mr-4 tracking-wide ${page == 'home' ? 'py-1.5' : ' text-gray-300 hover:text-gray-200'}`}><i className="fa-solid fa-house mr-1.5"></i>Home</Link></li>
                                <li><Link to={`/translate`} className={`lg:mr-2 xl:mr-4 tracking-wide  ${page == 'translate' ? 'py-1.5' : ' text-gray-300 hover:text-gray-200'}`}><i className="fa-solid fa-language mr-1.5"></i>Translate</Link></li>
                                <li><Link to={`/convert`} className={`lg:mr-2 xl:mr-4 tracking-wide  ${page == 'convert' ? 'py-1.5' : ' text-gray-300 hover:text-gray-200'}`}><i className="fa-solid fa-rotate mr-1.5"></i>Convert</Link></li>
                                <li><Link to={`/dub`} className={`lg:mr-2 xl:mr-4 tracking-wide  ${page == 'dub' ? 'py-1.5' : ' text-gray-300 hover:text-gray-200'}`}><i className="fa-solid fa-microphone mr-1.5"></i>Dub</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className='flex flex-row justify-center items-center gap-3'>
                        <button onClick={onToggleSidebar.bind(null, true)} type="button" className="block items-center lg:hidden">
                            <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path></svg>
                        </button>
                    </div>
                </div>
            </nav>
            { showSidebar && <div onClick={onToggleSidebar.bind(null, false)} className='w-full h-full z-30 fixed top-0 left-0 w-full'></div> }
            <aside id="navigation-sidebar" className={`fixed top-0 left-0 z-40 w-64 h-screen transition-all transition-transform ${showSidebar ? 'translate-x-0' : '-translate-x-full'}`} >
                <div className="h-full px-3 py-4 overflow-y-auto bg-gray-900 text-white">
                    <a href="#" className="flex items-center mr-10 px-1 py-1 mb-5 text-white text-xl">Subtitle Convert</a>
                    <ul className="space-y-1 mb-5">
                        <li key={'contact-us'}> <a href={`/contact-us`} className={`flex items-center px-3 py-1 text-gray-200 hover:text-white hover:bg-gray-700`}><i className="fa-solid fa-house mr-1.5"></i>Home</a></li>
                        <li key={'contact-us'}> <a href={`/contact-us`} className={`flex items-center px-3 py-1 text-gray-200 hover:text-white bg-gray-700 border-l-2`}><i className="fa-solid fa-language mr-1.5"></i>Translate</a></li>
                        <li key={'my-list'}> <a href={`/my-list`} className={`flex items-center px-3 py-1 text-gray-200 hover:text-white hover:bg-gray-700`}><i className="fa-solid fa-rotate mr-1.5"></i>Convert</a></li>
                    </ul>
                </div>
            </aside>
        </>
    )
}

export default React.memo(Navbar);